window.addEventListener('DOMContentLoaded', () => {
  const drawerEle = document.getElementById('drawer-list')

  drawerEle.addEventListener('click', toggleAccordion)

  function toggleAccordion(e) {
    let target = e.target;

    // get out of SVG or PATH element to get to ANCHOR element
    for (let i = 0; i < 3; i++) {
      if (target.getAttribute('href') === '#') {
        break;
      }

      target = target.parentElement;
    }

    // if target is not an ANCHOR element as an accordion, stop execution
    if (!(target.getAttribute('href') === '#')) {
      return;
    }

    e.preventDefault();
    target.classList.toggle('custom-menu-drawer__a-accordion--active');
  }

})